import { DropdownItem } from "types/dropdownItem";

/**
 * Maps an ID to its corresponding value from a list of dropdown items.
 * @param id - The ID to map.
 * @param list - The list of dropdown items, containing IDs and names.
 * @returns The name corresponding to the given ID, or undefined if no match is found.
 */
export const mapIdToValue = (id: string, list: DropdownItem[]): string | undefined => {
  const item = list.find((item) => item.id === id);
  return item ? item.name : undefined;
};
